module.exports = __webpack_public_path__ + "images/lipstick/incidents_page/Templates_empty-eb65360eb6c31a376ae5d30d3b856912.svg";